import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { Note } from '../note';
import { NewNote } from './newNote';

export const Notes = ({ queryParams, items = [], type, contactId }) => (
  <Flex flexDirection="column" sx={{ gap: '24px' }}>
    {type !== 'public' && <NewNote queryParams={queryParams} contactId={contactId} />}
    <Box>
      {items.length === 0 && type === 'public' && (
        <Text fontSize="14px" color="text.subtle" fontStyle="italic">
          No notes available for this contact.
        </Text>
      )}
      {items.map((item) => (
        <Flex
          key={item.id}
          py="24px"
          sx={{
            gap: '8px',
            borderTop: '1px solid',
            borderColor: 'border.subtle',
            ...(type === 'public'
              ? {
                  '&:first-of-type': {
                    borderTopWidth: 0,
                  },
                }
              : undefined),
          }}
        >
          <Note queryParams={queryParams} note={item} type={type} contactId={contactId} />
        </Flex>
      ))}
    </Box>
  </Flex>
);

Notes.propTypes = {
  queryParams: PropTypes.object,
  items: PropTypes.arrayOf(PropTypes.object),
  type: PropTypes.oneOf(['default', 'read', 'matches', 'public']),
  contactId: PropTypes.number.isRequired,
};

Notes.defaultProps = {
  queryParams: {},
  items: [],
  type: 'default',
};
